export { default } from './GroupRegistrationListPage';
